import { api, unwrap } from "./httpClient";

export interface ForceReleasePayload {
  userId: number;
  currency: string;
  amount: number;
  referenceId?: number;
}

export const forceReleaseLockedFunds = (payload: ForceReleasePayload) =>
  unwrap(
    api({
      method: "POST",
      url: "/admin/accounts/force-release",
      data: payload,
    })
  );

export interface LockedFundsDetails {
  tradingAccounts: Array<{
    id: number;
    currency: string;
    balance: number;
    lockedBalance: number;
  }>;
  pendingLimitOrders: Array<{
    id: number;
    symbol: string;
    side: "BUY" | "SELL";
    quantity: number;
    price: number | null;
    lockedAmount: number;
    createdAt: string;
  }>;
}

export const getLockedFundsDetails = (userId: number) =>
  unwrap<LockedFundsDetails>(
    api({
      method: "GET",
      url: `/admin/accounts/${userId}/locks`,
    })
  );

